import gql from 'graphql-tag';

/**
 * @param orderId optional order ID
 */
export const INTLLoyaltyIssuePoints = gql`
  mutation intlLoyaltyIssuePoints(
    $loyaltyId: String!
    $loyaltyUserCognitoId: String!
    $points: Int!
    $reason: String!
    $orderId: String
    $comments: String
  ) {
    intlLoyaltyIssuePoints(
      loyaltyId: $loyaltyId
      loyaltyUserCognitoId: $loyaltyUserCognitoId
      points: $points
      reason: $reason
      orderId: $orderId
      comments: $comments
    )
  }
`;
